let UA = window.ZZCFL.Utils.UA;
let userAgent = navigator.userAgent || '';
const isHarmony = /openharmony/.test(window.navigator.userAgent.toLowerCase());

function getiOSVersion() {
    const ua = userAgent.toLowerCase();
    if (ua.indexOf('like mac os x') > 0) {
        const reg = /os [\d._]*/gi;
        const verinfo = ua.match(reg);
        const version = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
        const arr = version.split('.');
        return Number(arr[0]) >= 14;
    }
    return false;
}

export default {
    isApp: /ZZC(Android|IOS|OpenHarmony)\/black\//.test(navigator.userAgent),
    isWechat: UA.browser.name === 'weixin',
    isWap: UA.browser.name !== 'black' && UA.browser.name !== 'weixin',
    isIos: UA.os.name === 'ios',
    isAndroid: UA.os.name === 'android',
    isSkeleton: /^SKELETON\//.test(userAgent),
    isAilPayApp: /alipayclient/.test(window.navigator.userAgent.toLowerCase()),
    isiOS14: getiOSVersion(),
    isHarmony,
    isHarmoneyQskApp: /ZZC(Android|IOS|OpenHarmony)\/black\//.test(navigator.userAgent) && isHarmony,
};
